// MUST run BEFORE `useAuth` is transitively imported — Zustand's persist
// middleware reads localStorage at store-creation time. ES module imports
// evaluate in source order, so these side-effect imports win.
//
// Order matters between the two: `impersonation` runs FIRST so an admin
// landing on V2 with `?impersonation_token=` swaps in the impersonation
// session even if a legacy CRA session is already in localStorage.
// `migrateLegacyAuth` then no-ops because the V2 key is already populated.
import '@/lib/auth/impersonation';
import '@/lib/auth/migrateLegacyAuth';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted fonts (Fontsource) — display serif + body sans
import '@fontsource/newsreader/300.css';
import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/500.css';
import '@fontsource/newsreader/600.css';
import '@fontsource/newsreader/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import './styles/globals.css';
// Rebinds Leaflet's default marker icon so any bare `L.marker()` still
// renders under Vite (the shipped default PNG URLs don't survive bundling).
// Custom `L.divIcon` markers used in-app don't need this, but it's cheap
// insurance for anything a future contributor adds.
import '@/lib/leafletBootstrap';
import { App } from '@/app/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
